<template>
  <div
    class="redetail-char"
    id="bar"
    @click="rechartm"
    style="position: relative"
  >
    <!-- <div @click="remov">消失</div> -->
    <div class="u-flex u-row-between">
      <div class="u-flex">
        <div class="u-flex" style="margin-right: 6px" v-if="typeobj.type > 2">
          <div class="chart-left">选择设备</div>
          <div>
            <Select
              @on-select="comconselctmth"
              v-model="ocmvalue"
              style="min-width: 140px;max-width:200px"
            >
              <Option
                v-for="item in ocmoption"
                :value="item.id"
                :key="item.id"
                >{{ item.value }}</Option
              >
            </Select>
          </div>
        </div>
        <div class="u-flex" style="margin-right: 6px" v-if="typeobj.type > 1">
          <div class="chart-left">选择润滑点</div>
          <div>
            <Select
              @on-select="conselctmth"
              v-model="comvalue"
              style="min-width: 140px;max-width:200px"
            >
              <Option
                v-for="item in comadminpotion"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </div>
        </div>
        <div class="u-flex">
          <div class="chart-left">选择指标</div>
          <div style="min-width: 200px; max-width: 300px; position: relative">
            <Cselcet
              @change="optenChange(false)"
              ref="selcet"
              :maxTag="2"
              :data="chatsList"
              clable="label"
              cvalue="value"
              v-model="list"
              @on-select="changeTag"
              :max="5"
              @click="Selectmetrics"
            />
          </div>
        </div>
        <Button
          type="primary"
          style="margin-left: 10px"
        
          @click="optenChange(false)"
          >查询</Button
        >
      </div>
      <div class="chart-right u-flex" style="position: relative; left: 7px">
    
      </div>
      <div class="u-flex char-statistics pot" @click.stop="statissShowmethods">
        <div class="stat-left" v-html="FormData.text"></div>
        <div class="pot pot-static-width">
          <Icon type="ios-arrow-down" />
        </div>
        <Statticdro
          :len="list.length"
          :m5coption="m5coption"
          :dataOptions="dataOptions"
          :statcCityOtiopn="statcCityOtiopn"
          :btns="btns"
          :FormData="FormData"
          :chartForm="chartForm"
          v-model="ccstataShow"
          @change="statuMethods"
        />
      </div>
    </div>

    <div class="u-rel chartop">
      <div class="uax pot" style="top: 42px" @click="shuaxecharts">
        <Tooltip theme="light" trigger="hover" content="刷新曲线">
          <img src="@/assets/images/resx.png" class="pot imgshuax" alt="" />
        </Tooltip>
      </div>
      <div
        class="rhdetiChat"
        :id="`rhdetiChat${index}`"
        :class="{ blurback: this.isEmtey }"
      ></div>
      <div class="blur" v-if="this.isEmtey">
        <Icon type="ios-alert-outline" size="20" color="#000" />
        <div class="emtifont">暂无数据</div>
      </div>
      <div class="axis-tip"></div>
      <div class="axis-btns">
        <div
          v-show="index.bo"
          :key="key"
          v-for="(index, key) in yAxistbns"
          :style="{ left: `${index.left}px` }"
          class="axis-btn"
          @click="btnclick(index, key)"
        >
          <img
            src="@/assets/images/ruler.png"
            class="pot"
            style="width: 16px; height: 16px"
          />
        </div>
      </div>
    </div>

    <div class="right-btns" style="padding-left: 15px" v-if="banbtnbo > 0">
      <div>
        <div class="u-flex">
          <div class="newRadio">
            <Radio
              v-model="btns.invalid"
              :disabled="datastacsbo"
              style="font-size: 12px"
            >
              <span :class="{ 'no-opt': datastacsbo }">显示无效值</span>
            </Radio>
            <div
              class="ridos"
              :class="{ 'no-opt': datastacsbo }"
              @click="radiomthInvalid()"
            ></div>
          </div>
          <div class="righ-btn no-opt" v-if="banbtnbo > 1 || !btns.invalid">
            <div class="u-flex btn-marin">
              <img
                src="@/assets/images/bdbj-icon.png"
                width="12px"
                height="12px"
                style="margin-right: 4px"
              />

              全部质量位
              <Icon type="ios-arrow-down" />
            </div>
          </div>
          <Dropdown v-else>
            <!-- @click.stop="clearimage()" -->
            <div
              class="righ-btn pot btn-marin"
              :class="{ 'btn-click': btns.invalid }"
            >
              <img
                src="@/assets/images/taiz.png"
                width="14px"
                height="12px"
                style="margin-right: 4px"
              />
              {{ markText }}
              <Icon type="ios-arrow-down" />
            </div>
            <DropdownMenu slot="list">
              <a
                href="javascript:;"
                @click="imaginary(vol)"
                v-for="(vol, key) in markOption"
                :key="key"
              >
                <DropdownItem>
                  {{ vol.label }}
                </DropdownItem>
              </a>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <!-- <div class="righ-btn pot ">
            触发虚无点
          </div> -->
      <div class="u-flex">
        <template>
          <div class="u-flex">
            <!--  -->
            <div
              v-if="btns.monotonicity && slopobj"
              class="shar-card"
              style="margin-right: 10px"
            >
              <div class="cartitem">
                日均变化比例：
                <span> {{ slopobj["daily_percent_%"] }}%</span>
              </div>
              <div class="lin"></div>
              <div class="cartitem">
                变化显著性(0-1)：
                <span> {{ slopobj.p_value }}</span>
              </div>
              <div class="lin"></div>
              <div class="cartitem">
                趋势：
                <span>
                  {{
                    slopobj.trend == "increasing"
                      ? "上升"
                      : slopobj.trend == "decreasing"
                      ? "下降"
                      : "无"
                  }}</span
                >
              </div>
            </div>
            <template>
              <div
                class="righ-btn pot"
                :class="{
                  'btn-click': btns.monotonicity,
                  'no-opt':
                    datastacsbo ||
                    banbtnbo > 1 ||
                    !isbtn.isMonotonicity ||
                    contrastbo,
                }"
              >
                <div
                  class="u-flex btn-marin"
                  :class="{
                    'no-vents':
                      datastacsbo ||
                      banbtnbo > 1 ||
                      !isbtn.isMonotonicity ||
                      contrastbo,
                  }"
                  @click="setMonotonicity(isbtn.monotonicity)"
                >
                  <img
                    src="@/assets/images/bdbj-icon.png"
                    width="12px"
                    height="12px"
                    style="margin-right: 4px"
                  />
                  单调性
                </div>
              </div>
            </template>
          </div>

          <template>
            <div
              class="righ-btn pot"
              :class="{
                'btn-click': btns.fluctuate,
                'no-opt': !isbtn.isFinite || banbtnbo > 1 || datastacsbo,
              }"
            >
              <div
                class="u-flex btn-marin"
                @click="setnewMaxWave(!isbtn.isFinite)"
                :class="{
                  'no-vents': !isbtn.isFinite || banbtnbo > 1 || datastacsbo,
                }"
              >
                <img
                  src="@/assets/images/bdbj-icon.png"
                  width="12px"
                  height="12px"
                  style="margin-right: 4px"
                />
                波动/变点
              </div>
            </div>
          </template>
          <template>
            <div
              class="righ-btn pot"
              :class="{
                'btn-click': btns.threshold,
                'no-opt': isbbtn || contrastbo || datastacsbo,
              }"
            >
              <div
                class="u-flex btn-marin"
                @click="isShildmth(!isbtn.isFinite)"
                :class="{
                  'no-vents': isbbtn || contrastbo || datastacsbo,
                }"
              >
                <img
                  src="@/assets/images/bdbj-icon.png"
                  width="12px"
                  height="12px"
                  style="margin-right: 4px"
                />
                阈值
              </div>
            </div>
          </template>
        </template>
        <Dropdown>
          <div
            class="righ-btn pot"
            :class="{
              'btn-click': btns.ledger,
              'no-opt': contrastbo || datastacsbo,
            }"
          >
            <div
              @click.stop="drwockar()"
              class="u-flex btn-marin"
              :class="{
                'no-vents': contrastbo || datastacsbo,
              }"
            >
              <img
                src="@/assets/images/taiz.png"
                width="14px"
                height="12px"
                style="margin-right: 4px"
              />
              {{ tztim }}
              <Icon type="ios-arrow-down" />
            </div>
          </div>
          <DropdownMenu slot="list" v-if="!contrastbo && !datastacsbo">
            <a
              href="javascript:;"
              @click="drowmeth(vol)"
              v-for="(vol, key) in tatusoption"
              :key="key"
            >
              <DropdownItem>
                {{ vol.describe }}
              </DropdownItem>
            </a>
          </DropdownMenu>
        </Dropdown>
        <div class="righ-btn pot btn-marin" @click="resetting('chongzhi')">
          重置
        </div>
      </div>
    </div>

    <chartRuler
      @change="rulemethods"
      :coruleobj="coruleobj"
      v-model="rulesopen"
    />
  </div>
</template>
<script>
import api from "@/api";
import { oilSiteModelVOLists } from "@/api/warning/diagnostic.js";
import * as Echarts from "echarts";
import Cselcet from "@/components/c-selectok/index";
let elementResizeDetectorMaker = require("element-resize-detector");
import throttle from "@/util/throttle.js";
import debounce from "@/util/debounce.js";
import chartRuler from "./chart-ruler";

import { getByDeviceId } from "@/api/operate/dataexprt";
import { ocmselect } from "@/api/business/rhlist";
import { accountstatus } from "@/api/pubrequst.js";

import moment from "moment";
import tz from "../mixin/taizhang";
import Statticdro from "./statticdro-model.vue";
export default {
  mixins: [tz],
  components: {
    Cselcet,
    chartRuler,
    Statticdro,
  },
  name: "redatalChaat",
  props: {
    oilSiteModelVOList: {
      type: Array,
    },
    char: {
      type: Object,
    },
    index: {
      type: [String, Number],
      default: 0,
    },

    option: {
      type: Object,
      default: () => null,
    },
    typeobj: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dataZoom: {},
      diaoilSiteId: null,
      ocmvalue: "",
      ocmoption: [],
      comvalue: "",
      comadminpotion: [],
      copyobj: {},
      reopbo: 0, //0 是没有预设 1是有约 2是有预设然后预设走完
      juearr: [],
      colorarr: [],
    };
  },

  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
  mounted() {
    this.moinit();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getContainerkWidth);
  },
  methods: {
    isyuzhiutil(vol) {
      const { oilSiteIdentifierIcon } = vol;
      if (
        oilSiteIdentifierIcon.secureLine == "上限" ||
        oilSiteIdentifierIcon.secureLine == "上下限" ||
        oilSiteIdentifierIcon.secureLine == "下限"
      ) {
        return true;
      } else {
        return false;
      }
    },
    chartJudgeArr(arr) {
      let arr1 = this.$c.deepClone(arr);
      let juearr = [];
      arr1.forEach((item) => {
        const { oilSiteIdentifierIcon } = item;
        const { isShow, secureLine, isMonotonicity } = oilSiteIdentifierIcon;
        let obj = {
          name: "",
          boshow: false,
          isFluctuate: false,
          hide: !this.isyuzhiutil(item),
          isMonotonicity,
        };
        obj["name"] = item.name;
        if (!!isShow) {
          if (!!oilSiteIdentifierIcon.secureLine) {
            obj.boshow = true;
          }
          if (!!oilSiteIdentifierIcon.isFluctuate) {
            obj.isFluctuate = true;
          }
        }
        juearr.push(obj);
      });

      this.juearr = juearr;
    },
    async conselctmth(item, text = "cre", arr = []) {
      // let comitem = this.comadminpotion.find((e) => e.value == item.value);

      //选择润滑点
      this.charRest(); //清空数组
      this.chatsList = [];
      let { data } = await oilSiteModelVOLists(item.value);
      let citem = this.comadminpotion.find((e) => item.value == e.value);

      this.typeobj.iotDeviceName = citem.iotDeviceName;
      this.typeobj.iotProductKey = citem.iotProductKey;
      this.typeobj.oilSiteId = citem.value;

      this.diaoilSiteId = citem.value;

      this.copyobj.oilSiteIotName = citem.oilSiteIotName;
      this.copyobj.oilSiteTypeId = citem.oilSiteTypeId;
      this.typeobj.oilSiteId = citem.id;
      this.chatsList = data.map((item) => {
        return {
          value: item.identifier,
          label: item.name,
        };
      });
      this.colorarr = data;
      this.chartJudgeArr(data);

      if (text == "init") {
        if (this.reopbo == 1) {
          this.list = arr.filter((e) => !!e);

          this.option = this.settootip(this.option);
         
          let server = this.option.series;
          if (server.length == 0) {
            this.isEmtey = true;
            this.$nextTick(() => {
              this.showemit();
            });
          } else {
            this.setOption(this.option);
            this.hideLoading(this.myChart);
          }
          this.reopbo = 2;
        } else {
          this.target();
          this.reopbo = 2;
        }
        return;
        //
      } else if (text == "chushihua") {
        this.sxchatszb().forEach((e) => {
          this.beforehand(e, "Multiple");
        });
      } else {
        this.seriess = [];
        this.showLoading(this.myChart);
        this.target(); //初始化折线图数据  润滑点的曲线
      }
    },

    banbomethd(option = null) {
      if (!option) {
        option == this.myChart.getOption();
      }
      let { series } = option;
      let len = 0;
      let arr = [
        "告警值(低)",
        "注意值(低)",
        "注意值(高)",
        "告警值(高)",
        "monot",
      ];
      series.forEach((e) => {
        if (e.type == "line") {
          if (!arr.includes(e.name)) {
            len++;
          }
        }
      });
      return len;
    },
    emit() {
      let option = this.myChart.getOption() || this.option;

      let chartForm = this.$c.deepClone(this.chartForm.date);
      chartForm[0] = moment(this.chartForm.date[0]).format("YYYY-MM-DD");
      chartForm[1] = moment(this.chartForm.date[1]).format("YYYY-MM-DD");
  
      if (option) {
        option.c = {
          ...chartForm,
        };

        option.id = {
          markObj: this.markObj, //存储他选第几个
          radioboarr: this.radioboarr, //这个是存储的曲线的无效值
          markPoints: this.markPoints, //单条曲线下拉的
          markOption: this.markOption,
          markText: this.markText,

          comvalue: this.comvalue,
          ocmvalue: this.ocmvalue,
          list: this.list,

          tztim: this.tztim,

          dataZoom: this.dataZoom,
          ledgerobj: this.ledgerobj, //台账
          btns: this.btns,
          isbtn: this.isbtn,
          slopobj: this.slopobj,
          noption: this.noption,
          demedata: this.demedata,
          cmarkPoints: this.cmarkPoints,
          comParTimeObj: this.comParTimeObj,
          FormData: this.FormData,
          namearr: this.namearr,
        };
      }

      this.$emit("getoption", option);
    },

    charRest() {
      this.seriess = [];
      this.yAxis = [];
    },

    comconselctmth(item, index = 3) {
      this.comvalue = undefined;
      this.list = [];
      this.comadminpotion = [];
      this.chatsList = [];

      this.getDevice(1, item.value);
    },

    async getCliaimDevice(index) {
      this.showLoading(this.myChart);
      let { data } = await ocmselect({
        //选择设备
        gangedValueMap: {
          tenantId: this.typeobj.customerId,
        },
        size: 200,
        type: "device",
        value: "",
      });
      this.ocmoption = data.records;

      if (data.records.length == 0) {
        //如果没有数据
        this.isEmtey = true;

        this.showemit();
      }

      let objitem;
      let reopbo = this.reopbo;
      if (reopbo == 0 || reopbo == 2) {
        //如果不是预设或者重新选择
        objitem = data.records[0];
      } else {
        let { ocmvalue } = this.option.id;

        if (ocmvalue) {
          objitem = this.ocmoption.find((e) => e.id == ocmvalue);
        } else {
          objitem = data.records[0];
        }
      }
      objitem = this.$c.deepClone(objitem);
      objitem.value = objitem.id;
      this.ocmvalue = objitem.value;
      this.comconselctmth(objitem, true);
    },
    async getDevice(bo, deviceId = this.typeobj.deviceId) {
      //请求融化点

      this.showLoading(this.myChart);
      let data = await getByDeviceId({
        deviceId,
      });

      if (data.length == 0) {
        //如果说润滑点没有数据的话
        this.isEmtey = true;

        this.showemit();
        return;
      }

      this.comadminpotion = data.map((item) => {
        const { id, name } = item;
        item.value = id;
        item.label = name;
        return item;
      });
 
      if (bo == 0) {
        //润滑点初始化

        if (this.reopbo == 0 || this.reopbo == 2) {
          this.comvalue = this.comadminpotion[0].value;
          this.conselctmth(
            {
              ...this.comadminpotion[0],
            },
            "init"
          );
        } else {
          // let arr = this.option.series.map((e) => e.stack);
          let arr = this.list;
          let { comvalue } = this.option.id;
          this.comvalue = comvalue;
          let finditem = this.comadminpotion.find((e) => e.value == comvalue);

          if (arr) {
            this.conselctmth(
              {
                //选择润滑点
                ...finditem,
              },
              "init",
              arr
            );
          } else {
            this.conselctmth(
              {
                //选择润滑点
                ...finditem,
              },
              "init"
            );
          }
        }
      } else if (bo == 1) {
        //设备初始化
   
        let comaitem;
        let arr;
        if (this.reopbo == 0 || this.reopbo == 2) {
          comaitem = this.comadminpotion[0];
        } else {
       
          arr = this.option.id.list;
          let { comvalue } = this.option.id;
          if (comvalue) {
            comaitem = this.comadminpotion.find((e) => e.value == comvalue);
          } else {
            comaitem = this.comadminpotion[0];
          }
        }
        comaitem = this.$c.deepClone(comaitem);

        this.comvalue = comaitem.value;
        if (arr) {
          this.conselctmth(
            {
              //选择润滑点
              ...comaitem,
            },
            "init",
            arr
          );
        } else {
          this.conselctmth(
            {
              //选择润滑点
              ...comaitem,
            },
            "init"
          );
        }
      }
    },
    sxchatszb() {
      let series = this.option.series;
      let list = this.chatsList.filter((e) => {
        let bo = false;
        series.forEach((fe) => {
          if (fe.name == e.label) {
            bo = true;
          }
        });
        return bo;
      });
      this.list = list.map((e) => e.value);
      return this.list;
    },

    cretchart() {
      //初始化echarts折线图
      let that = this;
      return new Promise((res, rej) => {
        this.myChart = Echarts.init(
          document.getElementById(`rhdetiChat${this.index}`),
          "light"
        );
        this.myChart.off("legendselectchanged"); //解决重复触发
        this.myChart.on("legendselectchanged", (e) => {
          let index = this.yAxistbns.findIndex((e1) => e1.name == e.name);
          let item = this.yAxistbns[index];
          item.bo = !item.bo;
          this.$set(this.yAxistbns, index, item);
        });

        this.myChart.on("mousemove", "yAxis", function (e) {
          let axisTip = document.querySelector(".axis-tip");
          axisTip.innerText = e.value;
          axisTip.style.left = e.event.offsetX + "px";
          axisTip.style.top = e.event.offsetY + 50 + "px";
          axisTip.style.display = "block";
        });

        this.myChart.on("mouseout", "yAxis", function (e) {
          let axisTip = document.querySelector(".axis-tip");
          axisTip.innerText = "";
          axisTip.style.display = "none";
        });
        this.myChart.on("datazoom", (params) => {
          debounce(() => {
            this.dataZoom = params[0];
            that.emit();
          });
        });

        this.myChart.on("mousemove", "series.line", (e) => {
          if (e.seriesType == "line") {
            const { seriesIndex, seriesName } = e;
            this.serobj = {
              seriesIndex,
              seriesName,
            };
          }
        });

        res();
      });
    },
    setyytimer(c) {
      this.chartForm.date = [
        moment(c[0]).format("YYYY-MM-DD HH:mm"),
        moment(c[1]).format("YYYY-MM-DD HH:mm"),
      ];
      this.timeObj = {
        startDateTime: new Date(moment(c[0])).getTime(),
        endDateTime: new Date(moment(c[1])).getTime(),
      };
    },
    async settarget() {
      //判断他是否是外层过来的
      this.showLoading(this.myChart);
      let { data } = await oilSiteModelVOLists(this.typeobj.oilSiteId);

      this.chatsList = data.map((item) => {
        return {
          value: item.identifier,
          label: item.name,
        };
      });
      this.chartJudgeArr(data);
      this.colorarr = this.oilSiteModelVOList;
      this.copyobj = this.$c.deepClone(this.char);

      this.diaoilSiteId = this.typeobj.oilSiteId; //润滑点直接通过typeobj获取台账的oilSiteId

      if (this.reopbo == 1) {
        //判断这个是否为空对象
        let option = this.option; //不为空直接赋值
        if (option.c) {
          //如果携带的timer 则使用这个timer
          const { list } = option.id;
          this.list = list;
        }
        if (option.series.length == 0) {
          this.isEmtey = true;
          this.showemit();
        } else {
          option = this.settootip(option);

          this.setOption(option);
          this.hideLoading(this.myChart);
        }

        this.reopbo = 2;
      } else {
        //为空则初始润滑点
        this.target();
        this.reopbo = 2;
      }
    },

    target(arr = [this.chatsList[0].label]) {
      //润滑点
    
      let showarr = this.chatsList.filter((chatitem) => {
        let item = arr.find((e) => e == chatitem.label);
        if (item) {
          return chatitem;
        }
      });
      if (showarr.length == 0) {
        showarr = [];

        if (this.chatsList.length == 1) {
          this.list = [this.chatsList[0].value];
        } else {
          this.list = [this.chatsList[0].value, this.chatsList[1].value];
        }
      } else {
        this.list = showarr.map((sitem) => sitem.value);
      }
      this.banbtnbo = this.list.length;
      if (this.list.length == 1) {
        this.isbtn = this.arrishow(this.chatsList[0].label);
      }
  
      this.$nextTick(() => {
        this.list.forEach((e) => {
          this.beforehand(e, "Multiple");
        });
      });
    },
    async init() {
      let accdata = await accountstatus(); //润滑点台账
      this.tatusoption = accdata.data;
      const { type } = this.typeobj;
      await this.cretchart(); //初始化折线图
      if (this.$c.isEmptyObject(this.option)) {
        //如果option为空对象
        this.reopbo = 0; //没有则是0
        let data1 = this.gettimer1(6, 0); //初始化7天的数据
        this.chartForm.date = [
          moment(data1.startDateTime).format("YYYY-M-D H:mm"),
          moment(data1.endDateTime).format("YYYY-M-D H:mm"),
        ];
        this.FormData.text = `
      <div class="u-flex">
        <div  class="right-4">统计维度: <span style="font-weight:bold">5分钟 |  </span></div>
         
        <div  class="right-4"> 统计方式: <span style="font-weight:bold">原始值 | </span></div>
              <div class=""right-4">统计周期: <span style="font-weight:bold">${moment(
                data1.startDateTime
              ).format(
                "YYYY-MM-DD"
              )} <span style="margin: 0 2px" >-</span> ${moment(
          data1.endDateTime
        ).format("YYYY-MM-DD")}</span></div>
        </div>
  
       </div> `;
        this.timeObj = {
          startDateTime: data1.startDateTime,
          endDateTime: data1.endDateTime,
        };
      } else {
        if (this.option.series.length == 1) {
          let name = this.option.series[0].name;
          if (name == "demo1") {
            this.option.series = [];
          }
        }
        if (this.option.series.length > 1) {
          this.zcolor = this.option.series[0].color;
        }
        this.reopbo = 1; //如果有预设就标识一下1
        if (this.option.c) {
          //如果携带的timer 则使用这个timer
          this.setyytimer(this.option.c); //设定时间
        }
        this.banbtnbo = this.banbomethd(this.option);

        if (this.option.id) {
          const {
            markText,
            markPoints,
            markOption,
            radioboarr,
            markObj,
            ledgerobj,
            btns,
            isbtn,
            slopobj,
            list,
            noption,
            demedata,
            cmarkPoints,
            comParTimeObj,
            FormData,
          } = this.option.id;
          
          this.banbtnbo = list.length;
          if (FormData) {
            this.FormData = FormData;
          }
          if (comParTimeObj && !this.$c.isEmptyObject(comParTimeObj)) {
            this.comParTimeObj = comParTimeObj;
          }
          if (cmarkPoints && !this.$c.isEmptyObject(cmarkPoints)) {
            this.cmarkPoints = cmarkPoints;
          }
          if (noption) {
            this.noption = noption;
          }
          if (list) {
            this.list = list;
          }
          if (slopobj) {
            this.slopobj = slopobj;
          }
          if (isbtn) {
            this.isbtn = isbtn;
          }
          if (ledgerobj) {
            this.ledgerobj = ledgerobj;
          }
          if (btns) {
            this.btns = btns;
          }

          if (demedata && !this.$c.isEmptyObject(demedata)) {
            this.demedata = demedata;
            this.tztim = demedata.describe;
          }

          if (radioboarr) {
            this.radioboarr = radioboarr;
          }

          if (markText) {
            this.markText = markText;
          }
       
          if (markObj) {
            this.markObj = markObj;
          }

          this.markPoints = markPoints;

          this.markOption = markOption;
        }
        if (this.option.yAxis && this.option.series.length > 0) {

          this.lincount(this.option);
        }
      }

      if (type == 3) {
        //初始化客户

        this.getCliaimDevice(0);
      } else if (type == 2) {
        this.getDevice(0); //初始化用户的
      } else {
        this.settarget(); //初始化润滑点的
      }
    },
  },
};
</script>
<style>
.redetail-char .ivu-tag .ivu-icon {
  display: none;
}

.redetail-char .ivu-tag .ivu-tag-text {
  margin-right: 0 !important;
}

.redetail-char .ivu-select-dropdown {
  overflow: auto;
}
</style>
<style scoped lang="less">
@import "../css/charts.css";
.rehtchats-title {
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.851);
  margin-bottom: 25px;
}

.chart-left {
  font-size: 12px;
  font-weight: 400;
  color: #555555;
  margin-right: 10px;
  white-space: nowrap;
}

.chart-right {
  display: flex;
}

.rhdetiChat {
  width: 100%;
  height: 312px;
}

.right-btns {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .righ-btn {
    opacity: 1;
    border: 1px solid #dddddd;
    background: #fafafa;
    display: flex;
    font-size: 12px;
    font-weight: 400;
    color: #878787;
    margin-right: 8px;
    line-height: 1;
    &:hover {
      background: #ffffff;
    }
  }

  .btn-click {
    background: rgba(0, 112, 204, 0.102) !important;
    border: 1px solid #0070cc !important;
    color: #0070cc !important;
  }
}

.ban-btn {
  cursor: no-drop;
}

h3.title {
  font-size: 24px;
  color: #000;
  margin: 10px 0 20px;
}

.axis-btns {
  position: absolute;

  top: 13px;
  z-index: 100;
  display: flex;

  .axis-btn {
    position: absolute;
  }
}

.newRadio {
  position: relative;

  .ridos {
    width: 90px;
    height: 22px;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: 100;
  }
}

.dis-btn {
  cursor: not-allowed !important;
  color: #c5c8ce !important;
  background-color: #f7f7f7 !important;
  border-color: #dcdee2 !important;
}

.axis-tip {
  display: none;
  position: absolute;
  padding: 5px 5px;
  font-size: 12px;
  line-height: 18px;
  color: #575757;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.shar-card {
  padding: 8px 20px;
  background: #f0f8ff;
  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.1);
  border-radius: 16px 16px 16px 16px;
  opacity: 1;
  font-size: 12px;
  display: flex;
  align-items: center;
  .cartitem {
    color: rgba(0, 0, 0, 0.45);

    span {
      color: #000000;
    }
  }
  .lin {
    width: 1px;
    height: 12px;
    background: #4e4d4d73;
    margin: 0 10px;
  }
}
.blur {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.73) 32%,
    #ffffff 100%
  );
  .emtifont {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-left: 3px;
  }
}
.blurback {
  filter: blur(4px);
}
</style>